/**
 * Created by lu on 2018/4/9.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    parent: nb.Model,
    method: {
        init: function () {

            // this.onChange('id', function (inEvent, inId) {          //itemCode
            //     this.set('href', 'brandDetail.html?id=' +  inId);  //转换字符串
            // }, this, {before: true});

        }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/brand/BrandItem.js
// module id = 537
// module chunks = 6